/**
 * Barrel Export für DB-Module
 */

// WICHTIG: PouchDB-Init muss als erstes exportiert werden,
// damit Plugins registriert sind bevor PouchDB verwendet wird
export * from './pouchdb-init';

export * from './db-connection-provider.interface';
export * from './base-pouchdb.service';
